<template>
  <RemotePaginatedList
    :filter-options="filterOptions"
    :headers="headers"
    multi-datasett
    v-model="selectedItemIds"
    data-url="admin/dataset/issue/"
    data-key="issues"
    :refresh-trigger.sync="innerRefreshTrigger"
    v-bind="$attrs"
    class="dataset-issue-list"
  >
    <template #item.period="{ value }">
      {{ $parsePeriod(value) }}
    </template>
    <template #item.imported_from_api="{ value }">
      <v-icon v-if="!value">mdi-hand-back-left</v-icon>
    </template>
    <template #item.last_updated_at="{ value }">
      <span>{{ value ? $parseDate(value, "yyyy-MM-dd HH:mm") : "-" }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <div class="d-flex">
        <v-btn
          v-if="canDelete && !item.imported_from_api"
          text
          color="primary"
          @click="deleteIssue(item)"
        >
          Delete
        </v-btn>
        <v-btn text color="primary" @click="editItem(item)"> More </v-btn>
        <v-btn text color="primary" @click="exportTemplate(item)">
          Export
        </v-btn>
      </div>
    </template>
  </RemotePaginatedList>
</template>

<script>
import { onMounted, ref, watch, computed } from "@vue/composition-api";
import RemotePaginatedList from "../RemotePaginatedList";
import _ from "lodash";
import { ACTION_TYPES } from "@/store/types";
import { USER_TYPE, PERMISSIONS } from "@/constants";

export default {
  name: "DatasetIssueList",
  components: { RemotePaginatedList },
  props: {
    value: Array,
    refreshTrigger: Boolean,
  },
  setup(props, { root, emit }) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    const canDelete = computed(() => {
      if (!root.$store.getters.account) return false;
      return (
        [USER_TYPE.SUPER_ADMIN].includes(root.$store.getters.account.type) ||
        _.some([PERMISSIONS.MANAGE_RBU_DATASET], (p) =>
          root.$store.getters.hasPermission(p)
        )
      );
    });
    onMounted(() => {
      refresh(false);
    });

    watch(
      () => props.refreshTrigger,
      (newValue) => {
        if (newValue) {
          refresh(true);
          emit("update:refresh-trigger", false);
        }
      }
    );

    // Filter
    const filterOptions = ref([]);

    // Data Table
    const headers = ref([
      { text: root.$t("dataset_issue.period"), value: "period" },
      {
        text: root.$t("dataset_issue.imported_from_api"),
        value: "imported_from_api",
      },
      { text: "Last Updated", value: "last_updated_at" },
      { text: "", value: "actions", width: 100, sortable: false },
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(
      () => selectedItemIds.value,
      (newValue) => {
        emit("input", newValue);
      }
    );
    watch(
      () => props.value,
      (newValue, oldValue) => {
        if (_.xor(newValue, oldValue).length) {
          selectedItemIds.value = newValue;
        }
      },
      { deep: true, immediate: true }
    );

    const editItem = async function (item) {
      root.$router.push({
        name: "rbu-dataset-issue",
        params: { datasetId: root.$route.params.datasetId, issueId: item.id },
      });
    };

    const deleteIssue = async function (item) {
      const result = await root.$dialog.confirm({
        text: `Delete Data Issue - ${root.$parsePeriod(item.period)} ?`,
      });

      if (result) {
        const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "admin/dataset/issue/delete/",
          params: { dataset_issue_id: item.id },
        });

        await refresh();
      }
    };

    const exportTemplate = async function (item) {
      const response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/issue/export/",
        params: { issue_id: item.id },
        opt: { extra: { responseType: "arraybuffer" } },
      });

      let blob = new Blob([response.data], {
        type: response.headers.get("content-type"),
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = item.period + ".xlsx";
      link.click();
    };

    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      editItem,
      deleteIssue,
      canDelete,
      exportTemplate,
    };
  },
};
</script>

<style lang="less">
.dataset-list {
}
</style>
